import { memo } from "react";
import { Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const ProductRowComp = ({ product, qty, total, disabled, onSetQty }) => {
  return (
    <div
      data-testid={`product-row-${product.id}`}
      className="flex items-center gap-2 py-2 border-b border-border/50 last:border-0"
    >
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium leading-tight truncate">{product.name}</div>
        {product.cond && (
          <div className="text-[11px] text-muted-foreground truncate">{product.cond}</div>
        )}
      </div>
      {total > 0 && (
        <span className="font-mono-num text-[11px] text-primary/80 bg-primary/10 rounded-full px-2 py-0.5 shrink-0">
          Σ {total}
        </span>
      )}
      <div className="flex items-center gap-1 shrink-0">
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          data-testid={`minus-${product.id}`}
          onClick={() => onSetQty(product.id, Math.max(0, +(qty - 1).toFixed(2)))}
          className="h-11 w-11 rounded-xl border-border bg-card active:scale-90 transition-transform"
        >
          <Minus className="h-4 w-4" />
        </Button>
        <Input
          type="number"
          inputMode="decimal"
          step="any"
          disabled={disabled}
          data-testid={`qty-${product.id}`}
          value={qty === 0 ? "" : qty}
          placeholder="0"
          onChange={(e) => onSetQty(product.id, e.target.value === "" ? 0 : Number(e.target.value))}
          onFocus={(e) => e.target.select()}
          className="h-11 w-16 text-center text-base font-mono-num font-bold rounded-xl bg-card border-border"
        />
        <Button
          variant="outline"
          size="icon"
          disabled={disabled}
          data-testid={`plus-${product.id}`}
          onClick={() => onSetQty(product.id, +(qty + 1).toFixed(2))}
          className="h-11 w-11 rounded-xl border-border bg-primary/10 text-primary active:scale-90 transition-transform"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export const ProductRow = memo(ProductRowComp);
